import { NgModule } from '@angular/core';
import { TodayComponent } from './today.component';
import { SharedProviderModule } from '../shared/shared.module';
import { VrgroupModule } from '../custom/vrgroup/vrgroup.module';
import { AlarmModule } from '../alarm/alarm.module';
import { OverlayPanelModule } from '../components/overlay-panel/overlay-panel.module';
import { WeatherModule } from '../weather/weather.module';
import { ClockModule } from '../components/clock/clock.module';
import { NotificationService } from '../components/notification/notification.service';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    AlarmModule,
    ClockModule,
    OverlayPanelModule,
    SharedProviderModule,
    NgbNavModule,
    VrgroupModule,
    WeatherModule
  ],
  declarations: [TodayComponent],
  exports: [TodayComponent],
  providers: [NotificationService]
})
export class TodayModule {
}
